import {
  matchStatusIds as mS,
  translationPrefixOddsMarketNameLive,
  translationPrefixOddsMarketNamePre,
} from '../constants/enum';


export function ordinalSuffixOf(input) {
  let i = input;
  if (typeof i === 'string') {
    switch (input.toLowerCase()) {
      case 'first':
        i = 1;
        break;
      case 'second':
        i = 2;
        break;
      case 'third':
        i = 3;
        break;
      case 'fourth':
        i = 4;
        break;
      case 'fifth':
        i = 5;
        break;
      default:
        i = 0;
        break;
    }
  }

  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return i + 'st';
  }
  if (j === 2 && k !== 12) {
    return i + 'nd';
  }
  if (j === 3 && k !== 13) {
    return i + 'rd';
  }
  return i + 'th';
}

const statuses = {
  [mS.not_started]: {
    en: 'not started',
  },
  [mS.halftime]: {
    en: 'HT',
  },
  [mS.pause]: {
    en: 'pause',
  },
  [mS.overtime]: {
    en: 'OT',
  },
  [mS.first_half]: {
    en: '1st half',
  },
  [mS.second_half]: {
    en: '2nd half',
  },
  [mS.first_period]: {
    en: '1st period',
  },
  [mS.second_period]: {
    en: '2nd period',
  },
  [mS.third_period]: {
    en: '3rd period',
  },
  [mS.fourth_period]: {
    en: '4th period',
  },
  [mS.first_set]: {
    en: '1st set',
  },
  [mS.second_set]: {
    en: '2nd set',
  },
  [mS.third_set]: {
    en: '3rd set',
  },
  [mS.fourth_set]: {
    en: '4th set',
  },
  [mS.fifth_set]: {
    en: '5th set',
  },
  [mS.first_quarter]: {
    en: '1st quarter',
  },
  [mS.second_quarter]: {
    en: '2nd quarter',
  },
  [mS.third_quarter]: {
    en: '3rd quarter',
  },
  [mS.fourth_quarter]: {
    en: '4th quarter',
  },
  [mS.first_extra]: {
    en: '1st extra',
  },
  [mS.second_extra]: {
    en: '2nd extra',
  },
  [mS.penalties]: {
    en: 'penalties',
  },
};

export const statusesLong = {
  [mS.not_started]: {
    en: 'not started',
  },
  [mS.halftime]: {
    en: 'HT',
  },
  [mS.first_half]: {
    en: '1st half',
  },
  [mS.second_half]: {
    en: '2nd half',
  },
  [mS.first_period]: {
    en: 'first period',
  },
  [mS.second_period]: {
    en: 'second period',
  },
  [mS.third_period]: {
    en: 'third period',
  },
  [mS.fourth_period]: {
    en: 'fourth period',
  },
  [mS.first_set]: {
    en: 'first set',
  },
  [mS.second_set]: {
    en: 'second set',
  },
  [mS.third_set]: {
    en: 'third set',
  },
  [mS.fourth_set]: {
    en: 'fourth set',
  },
  [mS.fifth_set]: {
    en: 'fifth set',
  },
  [mS.first_quarter]: {
    en: 'first quarter',
  },
  [mS.second_quarter]: {
    en: 'second quarter',
  },
  [mS.third_quarter]: {
    en: 'third quarter',
  },
  [mS.fourth_quarter]: {
    en: 'fourth quarter',
  },
  [mS.overtime]: {
    en: 'OT',
  },
  [mS.first_extra]: {
    en: 'first extra',
  },
  [mS.second_extra]: {
    en: 'second extra',
  },
  [mS.penalties]: {
    en: 'penalties',
  },
};

export const getMatchStatusStr = (matchStatusId, lang = 'en') => {
  if (statuses[matchStatusId] && statuses[matchStatusId][lang]) {
    return statuses[matchStatusId][lang];
  }

  return '';
};


export const getLocalMarketName = (marketId, sportId, lang, srAlias, translations, intl, type) => {
  let sportOddsMarketNameKey = `${translationPrefixOddsMarketNameLive}${sportId}_${marketId}`;

  if (type === 'prematch') {
    sportOddsMarketNameKey = `${translationPrefixOddsMarketNamePre}${sportId}_${marketId}`;
  }

  if (translations && translations[sportOddsMarketNameKey]) {
    return intl.formatMessage({ id: sportOddsMarketNameKey });
  }

  return null;
};
